import React, {Fragment} from "react";

const LoginHeader = (props) => {
  return (
    <Fragment>
      <div className="width_690">
        <p className="font-16 text-white weight-600 text-center margin-bottom-12">
          Don't miss the opportunity to meet your patient's need.
        </p>
        <p className="font-16 text-white weight-600 text-center">
          Maximize the capabilities of remote consultation and counselling, and
          provide to your patients wherever they are
        </p>
      </div>

      <div className="footer_custom d-flex justify-content-center margin-top-20">
        <p className="margin-0 font-12 weight-500 text-white">
          © 2022 addvantage-technologies.co.uk
        </p>
        <p className="margin-0 font-12 weight-500 text-white">
          <a rel="noreferrer" className="text-white text-white-hover" href="https://www.alldaydr.com/terms_condition" target={"_blank"} title="Terms and Conditions">
              Terms &amp; Conditions
          </a>
        </p>
        <p className="margin-0 font-12 weight-500 text-white">
          {JSON.parse(localStorage.getItem("APP_VERSION"))}
        </p>
        <p className="margin-0 font-12 weight-500 text-white">
          <a rel="noreferrer" className="text-white text-white-hover" href="https://www.alldaydr.com/privacy_policy" target={"_blank"} title="Privacy Policy">
            Privacy Policy
          </a>
        </p>
      </div>
    </Fragment>
  );
};

export default LoginHeader;
